/* unplugin-vue-components disabled */import script from "./button-icon.vue?vue&type=script&setup=true&lang=ts"
export * from "./button-icon.vue?vue&type=script&setup=true&lang=ts"

import "./button-icon.vue?vue&type=style&index=0&id=272cdd89&lang=css"

const __exports__ = script;

export default __exports__